import mock from "./mock";
import "./notes/NotesData";

mock.onAny().passThrough();
